import Vue from 'vue';
import { httpClient } from '@/utils/request/http';

/**
 * Contador de notificações não lidas do condômino (badge do menu).
 * Atualiza ao montar o menu e ao ler uma notificação — sem polling.
 */
const state = Vue.observable({
	naoLidas: 0
});

function atualizar() {
	return httpClient.get('/condomino/avisos/nao-lidas')
		.then((response) => { state.naoLidas = response?.data?.data?.total || 0; })
		.catch(() => {});
}

function marcarLida() {
	state.naoLidas = Math.max(0, state.naoLidas - 1);
}

export default { state, atualizar, marcarLida };
